// react redux
import { useSelector } from "react-redux";
// react router dom
import { Routes, Route } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
// pages
import Login from "../pages/Login/Login";
import Categories from "../pages/Categories/Categories";
import ProductListing from "../pages/ProductListing/ProductListing";
import ProductDescription from "../pages/ProductDescription/ProductDescription";
import Cart from "../pages/Cart/Cart";
import MechanicCollectionSkus from "../pages/MechanicCollectionSkus/MechanicCollectionSkus";
// react router dom
import { Navigate } from "react-router-dom";

const Router = () => {
  const user = useSelector((state) => state.auth);
  const { id: userId } = user;

  let routes = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
  if (userId) {
    routes = (
      <Routes>
        <Route path="/" element={<Categories />} />
        <Route path="/skus" element={<ProductListing />} />
        <Route
          path="/sku/mechanicCollection/*"
          element={<MechanicCollectionSkus />}
        />
        <Route path="/product/:productId" element={<ProductDescription />} />
        <Route path="/my-cart" element={<Cart />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }
  return <BrowserRouter>{routes}</BrowserRouter>;
};

export default Router;
